export default __webpack_public_path__ + "static/media/liftwithbanner.57571d16.jpg";